export const ACTIVE_RECORDS_VIEW = "active";
export const TRASH_RECORDS_VIEW = "trash";
export const LEAD_COUNTS_CHANGED_EVENT = "lead-counts-changed";

export function notifyLeadCountsChanged() {
  window.dispatchEvent(new Event(LEAD_COUNTS_CHANGED_EVENT));
}

export function isTrashRecordsView(view) {
  return view === TRASH_RECORDS_VIEW;
}

/**
 * Frontend contract for soft-delete aware list APIs.
 * Backend should interpret:
 * - `deletedState=active` => only records where deleted_at IS NULL
 * - `deletedState=trash` => only soft-deleted records
 */
export function buildSoftDeleteListParams(view) {
  return {
    deletedState: isTrashRecordsView(view)
      ? TRASH_RECORDS_VIEW
      : ACTIVE_RECORDS_VIEW,
  };
}
